const color = {
    darkslategray: '#212B36', // BLACK
    dodgerblue: '#236FFF', // BLUE
    lavender: '#236FFF33', // LIGHT BLUE
    slategray: '#637381', // GRAY
}

export default color